import { render, staticRenderFns } from "./RepresentativesPage.vue?vue&type=template&id=48926519&"
import script from "./RepresentativesPage.vue?vue&type=script&lang=js&"
export * from "./RepresentativesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports